import redirectTemplate from './stripeRedirect.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider.state('stripeRedirect', {
    url: '/striperedirect',
    template: redirectTemplate,
    controller: 'StripeRedirectCtrl',
    controllerAs: 'stripevm'
  });
}];
